import { render } from "./a-fumbi-testimonials.vue?vue&type=template&id=594a86d3&scoped=true"
import script from "./a-fumbi-testimonials.vue?vue&type=script&lang=js"
export * from "./a-fumbi-testimonials.vue?vue&type=script&lang=js"

import "./a-fumbi-testimonials.vue?vue&type=style&index=0&id=594a86d3&lang=sass&scoped=true"

import exportComponent from "/opt/bitnami/apps/ocmsta/subdomains/academy/htdocs/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-594a86d3"]])

export default __exports__